import { createContext, useContext } from "react";

import { useReportsCtxProvider } from "../hooks";

export type IUseReports = ReturnType<typeof useReportsCtxProvider>;

const ReportsContext = createContext<IUseReports>({} as IUseReports);

ReportsContext.displayName = "ReportsContext";

export const useReportsContext = (): IUseReports => useContext(ReportsContext);

export { ReportsContext };
